import { render, staticRenderFns } from "./DomainsNameserverChecker.vue?vue&type=template&id=4391b6ff"
import script from "./DomainsNameserverChecker.vue?vue&type=script&lang=js"
export * from "./DomainsNameserverChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports